import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox, FormControlLabel, Grid } from '@material-ui/core';
import { Check } from '@material-ui/icons';
import FormTextInput from 'components/FormTextInput/FormTextInput';

const GoogleTagManagerModule = ({ classes, handleModuleUpdate, module }) => {
  const { t } = useTranslation();

  if (!module) {
    return (
      <div>
        {t('brands.newBrandForm.moduleNotLoaded', {
          defaultValue: '{{moduleName}} not loaded.',
          moduleName: 'GoogleTagManagerModule',
        })}
      </div>
    );
  }

  return (
    <Fragment>
      <Grid container={true}>
        <Grid item={true} md={12}>
          <FormControlLabel
            control={
              <Checkbox
                checked={module.enabled}
                // eslint-disable-next-line @typescript-eslint/no-unused-vars -- FIXME
                onChange={e =>
                  handleModuleUpdate({
                    ...module,
                    enabled: !module.enabled,
                    useEcommerce: !module.enabled,
                    useEnhancedEcommerce: !module.enabled,
                  })
                }
                checkedIcon={<Check className={classes.checkedIcon} />}
                icon={<Check className={classes.uncheckedIcon} />}
                classes={{
                  checked: classes.checked,
                  root: classes.checkRoot,
                }}
              />
            }
            label="Google Tag Manager"
          />
          <FormTextInput
            label={t('brands.newBrandForm.GTMCode', 'Kod Google Tag Manager')}
            classes={classes}
            name="googleTagManager"
            value={module.code}
            maxLength={30}
            handleChange={e =>
              handleModuleUpdate({ ...module, code: e.target.value })
            }
            inputSize={12}
          />
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default GoogleTagManagerModule;
